import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";
export function PyloTooltip({ children, content, side = "bottom", align = "center", delayDuration = 300, className, sideOffset = 4, avoidCollisions = true, disabled = false, }) {
    if (disabled) {
        return <>{children}</>;
    }
    return (<TooltipProvider>
      <Tooltip delayDuration={delayDuration}>
        <TooltipTrigger asChild>
          <div>{children}</div>
        </TooltipTrigger>
        <TooltipContent side={side} align={align} className={className} sideOffset={sideOffset} avoidCollisions={avoidCollisions}>
          <p className="text-xs">{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>);
}
